// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "chunks/" + ({"240":"booking","329":"datepicker","415":"details","926":"lightgallery"}[chunkId] || chunkId) + "." + {"72":"fc3fc0c26f80608350c7","240":"84c78bee38bd36ee3356","329":"30935f07860a9dd2f00d","415":"2db1c81191ed0674cc7b","926":"f64caef643df80bcc243"}[chunkId] + ".js";
};